import tw, { styled } from 'twin.macro';
import InputBase from 'styles/basic/InputBase';

export const StyledSelect = styled(InputBase).attrs(() => ({
    as: 'select'
}))`
    && {
        ${({ size }) => size === 'small' && tw`pl-2 pr-7`}
    }
`;